module.exports = __webpack_public_path__ + "media/images/icons/material/chill-red-3f39ba03e58a5ca35a3716bbf42ad7cf.svg";